// Baureihe, Baujahr und Karosserie aus dem Produkttitel lesen und je Modell zu Auswahl-Optionen bündeln.
// Eigene Datei, damit sie lokal mit Node gegen alle Produkttitel getestet werden kann.
(function (root) {
  const BODIES = [
    [/\bGran(?:d)?\s+Coup[eé]\b/i, 'Gran Coupé'],
    [/\bActive\s+Tou\w*/i, 'Active Tourer'],
    [/\bGran\s+Turismo(?:\s+GT)?\b/i, 'Gran Turismo'],
    [/\bGran\s+Tourer\b/i, 'Gran Tourer'],
    [/\bSports?\s*Tourer\b/i, 'Sports Tourer'],
    [/\bShooting\s+Brake\b/i, 'Shooting Brake'],
    [/\bAllroad(?:\s+quattro)?\b/i, 'Allroad'],
    [/\bLimousine\b/i, 'Limousine'],
    [/\bAvant\b/i, 'Avant'],
    [/\bSportback\b/i, 'Sportback'],
    [/\bVariant\b/i, 'Variant'],
    [/\bAlltrack\b/i, 'Alltrack'],
    [/\bT-Modell\b/i, 'T-Modell'],
    [/\bTouring\b/i, 'Touring'],
    [/\bKombi\b/i, 'Kombi'],
    [/\bEstate\b/i, 'Kombi'],
    [/\bSW\b/, 'Kombi'],
    [/\bSportswagon\b/i, 'Kombi'],
    [/\bSportsvan\b/i, 'Sportsvan'],
    [/\bCabrio(?:let)?\b/i, 'Cabrio'],
    [/\bCoup[eé]\b/i, 'Coupé'],
    [/\bFastback\b/i, 'Fastback'],
    [/\bTourer\b/i, 'Tourer'],
    [/\bClubman\b/i, 'Clubman'],
    [/\bCountryman\b/i, 'Countryman'],
    [/\bSUV\b/, 'SUV'],
  ];

  // Wörter, die nichts über das Fahrzeug sagen (Farbe, Produktart, Displaydetails)
  const NOISE = [
    /\bSchwarz\s*Matt\b/gi, /\bTransparent\b/gi, /\bCarbon\b/gi, /\bLackschutz\w*\b/gi, /\bGriffmulden?\b/gi,
    /\bSchutzfolie\b/gi, /\bpassgenau\b/gi, /\bSet\b/gi, /\d+(?:[.,]\d+)?\s*(?:Zoll|"|”)/gi, /\bNavi\w*\b/gi,
    /\bMMI\b/gi, /\bEntspiegelt\b/gi, /\bAnti-?Fingerprint\b/gi, /\bMatt\b/gi, /\b\w*Displays?\b/gi,
    /\bPanorama\b/gi, /\bOLED\b/gi, /\bWidescreen\b/gi, /\bKlima\w*\b/gi, /\b\d-teilig\b/gi, /\bInfotainment\b/gi,
    /\bTacho\w*\b/gi, /\bCockpit\b/gi, /\bMultimedia\b/gi, /\bTouchscreen\b/gi, /\bScreen\b/gi, /\bquattro\b/gi,
    /\bund\b/gi, /\bmit\b/gi, /\bohne\b/gi, /\bModell\b/gi,
  ];

  const QUALIFIERS = [[/\be-?tron\b/i, 'e-tron'], [/\bFace(?:lift)?\b|\bLCI\b/i, 'Facelift'], [/\bPlug-?in\b/i, 'Plug-in']];
  // Ausstattung mit eigener Stoßstange -> eigene Auswahl
  const TRIMS = [[/\bM[\s-]?Paket\b/i, 'M-Paket'], [/\b(N|GS|R|S|AMG)[\s-]Line\b/i, (m) => `${m[1].toUpperCase()} Line`]];
  const CODE = /^(?:\d{3}(?:\.\d)?|[A-Z]{1,3}\d{1,3}[A-Z]?|\d{1,2}[A-Z]{1,2}|[A-Z]{2}|[IVX]{1,4}|\d{1,2}|[A-Z])$/;
  const NOT_CODE = new Set(['AB', 'GS', 'GT', 'RS', 'ST', 'SB', 'PHEV', 'EV', 'LINE', 'M', 'S', 'AMG']);

  const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const fullYear = (y) => (y.length === 2 ? Number(`20${y}`) : Number(y));

  function parse(model, rest) {
    let s = ` ${rest} `.replace(/\b([A-Z])\s(\d{3})\b/g, '$1$2');
    // Modellnamen vorne entfernen ("A6 C7 …" -> "C7 …", "ID 7 …" bei Modell "ID.7")
    const chars = model.replace(/[\s.\-]/g, '').split('').map(esc).join('[\\s.\\-]?');
    s = s.replace(new RegExp(`^\\s*${chars}(?![a-z])`, 'i'), ' ');

    const qualifiers = [];
    QUALIFIERS.forEach(([re, name]) => {
      if (re.test(s)) {
        qualifiers.push(name);
        s = s.replace(re, ' ');
      }
    });

    let trim = '';
    TRIMS.forEach(([re, name]) => {
      const m = s.match(re);
      if (m && !trim) {
        trim = typeof name === 'function' ? name(m) : name;
        s = s.replace(re, ' ');
      }
    });

    let bodies = [];
    BODIES.forEach(([re, name]) => {
      if (re.test(s)) {
        if (!bodies.includes(name)) bodies.push(name);
        s = s.replace(new RegExp(re.source, re.flags.includes('g') ? re.flags : `${re.flags}g`), ' ');
      }
    });
    // "Avant Allroad" ist der Allroad
    if (bodies.includes('Allroad')) bodies = bodies.filter((b) => b !== 'Avant');
    if (trim) bodies = (bodies.length ? bodies : ['']).map((b) => `${b} ${trim}`.trim());

    NOISE.forEach((re) => {
      s = s.replace(re, ' ');
    });
    s = s.replace(/\b\d+,\d+\b/g, ' ');

    let from = null;
    let to = null;
    const range = s.match(/\b((?:19|20)\d{2})\s*[-–]\s*((?:19|20)?\d{2})\b/) || s.match(/\b(\d{2})\s*[-–]\s*((?:19|20)\d{2})\b/);
    if (range) {
      from = fullYear(range[1]);
      to = fullYear(range[2]);
      s = s.replace(range[0], ' ');
    } else {
      const ab = s.match(/\bab\s+((?:19|20)?\d{2})\b/i);
      if (ab) {
        from = fullYear(ab[1]);
        s = s.replace(ab[0], ' ');
      } else {
        const single = s.match(/\b((?:19|20)\d{2})\b/);
        if (single) {
          from = Number(single[1]);
          s = s.replace(single[0], ' ');
        }
      }
    }

    const codes = [];
    s.replace(/[()\/,+&]/g, ' ')
      .split(/\s+/)
      .filter(Boolean)
      .forEach((tok) => {
        if (CODE.test(tok) && !NOT_CODE.has(tok.toUpperCase()) && !codes.includes(tok.toUpperCase())) {
          codes.push(tok.toUpperCase());
        }
      });

    return { codes, from, to, bodies, qualifiers };
  }

  function yearLabel(from, to) {
    if (!from) return '';
    return to ? `${from}–${to}` : `ab ${from}`;
  }

  const count = (list) => {
    const m = new Map();
    list.forEach((v) => m.set(v, (m.get(v) || 0) + 1));
    return Array.from(m.entries()).sort((x, y) => y[1] - x[1]).map((e) => e[0]);
  };
  // "7 VII" -> "7": römische Generationsnummer weglassen, wenn dieselbe Zahl schon dasteht
  const ROMAN = { I: 1, II: 2, III: 3, IV: 4, V: 5, VI: 6, VII: 7, VIII: 8, IX: 9, X: 10 };
  const dropRoman = (codes) => codes.filter((c) => !(ROMAN[c] && codes.includes(String(ROMAN[c]))));
  const etron = (f) => f.qualifiers.includes('e-tron');
  const facelift = (f) => f.qualifiers.includes('Facelift');
  const isHandle = (item) => item.type === 'Griffmulden-Schutzfolie';
  // Displayfolien passen unabhängig von der Karosserie (gleicher Innenraum)
  const bodyFree = (item) => item.type === 'Display-Schutzfolie';

  // gleiche Baureihe: gleicher Code ODER (ohne Code) gleiches Startjahr ±1; nicht über Facelift/Folgejahre hinweg
  function sameGeneration(a, b, ignoreFacelift) {
    if (etron(a) !== etron(b)) return false;
    if (!ignoreFacelift && facelift(a) !== facelift(b)) return false;
    if ((a.to && b.from && b.from >= a.to) || (b.to && a.from && a.from >= b.to)) return false;
    const shared = a.codes.some((c) => b.codes.includes(c));
    const noCode = !a.codes.length || !b.codes.length;
    const sameYear = a.from && b.from && Math.abs(a.from - b.from) <= 1;
    return shared || Boolean(noCode && sameYear);
  }

  // Baujahre je Option (zuletzt gebautes Modell), damit z. B. ein Display "ab 2022" nicht bei "2019–2022" erscheint
  const ranges = new Map();
  const disjoint = (a, b) => Boolean((a.to && b.from && b.from >= a.to) || (b.to && a.from && a.from >= b.to));

  // items: [{ model, rest, type, ... }] eines Modells -> setzt item.gens und liefert die Optionen
  function buildOptions(items) {
    items.forEach((item) => {
      item.fit = parse(item.model, item.rest);
      item.gens = [];
      item.plainBody = false;
    });
    const dated = items.filter((item) => item.fit.codes.length || item.fit.from);
    // ohne Code und ohne Jahr: passt zu allen Baureihen des Modells
    items.filter((item) => !dated.includes(item)).forEach((item) => {
      item.gens = ['*'];
    });

    // Ladekanten bilden die Baureihen; Displays und Türgriff-Folien hängen sich an alle passenden Baureihen an
    // (z. B. Display "GLC X253 Facelift 2019–2022" zur Ladekante "GLC X253 2015–2022")
    const isEdge = (item) => item.type === 'Ladekantenschutz';
    const core = dated.filter(isEdge);
    const parent = core.map((_, i) => i);
    const find = (i) => (parent[i] === i ? i : (parent[i] = find(parent[i])));
    for (let i = 0; i < core.length; i += 1) {
      for (let j = i + 1; j < core.length; j += 1) {
        if (sameGeneration(core[i].fit, core[j].fit, false)) parent[find(i)] = find(j);
      }
    }
    const groups = new Map();
    core.forEach((item, i) => {
      const key = `g${find(i)}`;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
      item.gens = [key];
    });

    const extras = dated.filter((item) => !isEdge(item));
    const loose = [];
    extras.forEach((item) => {
      groups.forEach((members, key) => {
        if (members.some((m) => sameGeneration(m.fit, item.fit, true))) item.gens.push(key);
      });
      if (!item.gens.length) loose.push(item);
    });
    // ohne passende Ladekante: eigene Baureihe (Facelift zählt nur bei Displays)
    loose.forEach((item, i) => {
      const other = loose
        .slice(0, i)
        .find((o) => sameGeneration(o.fit, item.fit, isHandle(o) || isHandle(item)));
      const key = other ? other.gens[0] : `h${i}`;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
      item.gens = [key];
    });

    const options = [];
    ranges.clear();
    groups.forEach((own, key) => {
      const members = items.filter((m) => m.gens.includes(key));
      const core = own.filter((m) => !isHandle(m)).length ? own.filter((m) => !isHandle(m)) : own;
      const yearsOf = (list) => count(list.filter((m) => m.fit.from).map((m) => yearLabel(m.fit.from, m.fit.to)));
      // Codes aus Buchstaben + Ziffern (8Y, G22, F5) vor Generationsnummern (IV, 4)
      const strong = (c) => (/[A-Z]/.test(c) && /\d/.test(c) ? 0 : 1);
      const codesOf = (list) => {
        const ranked = count(list.flatMap((m) => m.fit.codes));
        return ranked.sort((a, b) => strong(a) - strong(b) || ranked.indexOf(a) - ranked.indexOf(b)).slice(0, 2);
      };
      const from = Math.min(...core.filter((m) => m.fit.from).map((m) => m.fit.from).concat([9999]));
      const prefix = core.some((m) => etron(m.fit)) ? 'e-tron ' : '';
      const fl = core.every((m) => facelift(m.fit)) ? ' Facelift' : '';
      // Beschriftung aus den Artikeln genau dieser Auswahl, sonst aus der ganzen Baureihe
      const rangeOf = (list) => {
        const top = yearsOf(list)[0];
        const m = list.find((x) => x.fit.from && yearLabel(x.fit.from, x.fit.to) === top);
        return m ? { from: m.fit.from, to: m.fit.to } : null;
      };
      const add = (value, list, body) => {
        const r = rangeOf(list);
        if (r) ranges.set(value, r);
        const own = list.filter((x) => x.fit.from).map((x) => x.fit.from);
      options.push({ value, label: label(list, body), from: own.length ? Math.min(...own) : from });
      };
      // Ladekanten mit getrennten Baujahren (2014–2019 / ab 2019) bekommen je eine eigene Auswahl
      // Artikel ohne Baujahr ("S212 Transparent") gehören zur ersten Jahresgruppe, nicht in eine eigene Auswahl
      const splitByYears = (list) => {
        const clusters = [];
        const undated = [];
        list.forEach((m) => {
          if (!m.fit.from) {
            undated.push(m);
            return;
          }
          const hit = clusters.find((c) => c.some((x) => !disjoint(x.fit, m.fit)));
          if (hit) hit.push(m);
          else clusters.push([m]);
        });
        if (!clusters.length) return [undated];
        clusters[0].push(...undated);
        return clusters;
      };
      const addSplit = (prefixValue, list, body) => {
        const clusters = splitByYears(list);
        clusters.forEach((cluster, i) => add(clusters.length > 1 ? `${prefixValue}|${i}` : prefixValue, cluster, body));
      };
      // "8 CD · ab 2019", "W213 Facelift · 2020–2023 T-Modell"; ohne Code: "Sportsvan · ab 2014", "Facelift · 2021–2023"
      const label = (list, body) => {
        const codes = dropRoman(codesOf(list).length ? codesOf(list) : codesOf(core));
        const yrs = yearsOf(list)[0] || yearsOf(core)[0] || '';
        const head = `${prefix}${codes.join(' ')}${fl}`.trim();
        if (!codes.length) return [[head, body].filter(Boolean).join(' '), yrs].filter(Boolean).join(' · ');
        return `${[head, yrs].filter(Boolean).join(' · ')} ${body}`.trim();
      };

      const bodies = count(members.filter((m) => m.type === 'Ladekantenschutz').flatMap((m) => m.fit.bodies));
      if (!bodies.length) {
        const lk = core.filter((m) => m.type === 'Ladekantenschutz');
        if (lk.length) addSplit(`${key}|`, lk, '');
        else add(`${key}|`, core, '');
        return;
      }
      // Ladekante ohne Karosserie neben Varianten mit Karosserie = Grundmodell (z. B. Q4 e-tron neben Q4 Sportback)
      const plain = members.filter((m) => m.type === 'Ladekantenschutz' && !m.fit.bodies.length);
      plain.forEach((m) => {
        m.plainBody = true;
      });
      if (plain.length) addSplit(`${key}|-`, plain, '');
      bodies.sort((a, b) => a.localeCompare(b, 'de'));
      bodies.forEach((body) => {
        const exact = members.filter((m) => m.type === 'Ladekantenschutz' && m.fit.bodies.includes(body));
        addSplit(`${key}|${body}`, exact, body);
      });
    });
    // neueste Baureihe zuerst
    options.sort((a, b) => b.from - a.from || a.label.localeCompare(b.label, 'de', { numeric: true }));
    return options;
  }

  function matches(item, value) {
    if (item.gens.includes('*')) return true;
    const [gen, body] = value.split('|');
    if (!item.gens.includes(gen)) return false;
    if (ranges.has(value) && disjoint(item.fit, ranges.get(value))) return false;
    if (!body || bodyFree(item)) return true;
    const own = item.fit.bodies;
    if (body === '-') return !own.length;
    if (!own.length) return !item.plainBody;
    if (own.includes(body)) return true;
    // Türgriff-Folien: "Touring" passt auch zu "Touring M-Paket"
    return item.type !== 'Ladekantenschutz' && own.some((b) => body.startsWith(`${b} `));
  }

  const api = { parse, buildOptions, matches };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.VehicleVariant = api;
})(typeof window !== 'undefined' ? window : this);
